import { useFlag } from '@cognite/react-feature-flags';
import { createContext } from 'react';

export interface AppConfigUseFlagContextInterface {
  useFlag: typeof useFlag;
}

export const defaultValue: AppConfigUseFlagContextInterface = {
  useFlag,
};

export const AppConfigUseFlagContext =
  createContext<AppConfigUseFlagContextInterface>(defaultValue);
